import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons';

const emailRegex = RegExp(
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  );

const formValid = ({ formErrors, ...rest}) => {
    let valid = true;

    //validate form errors being empty
    Object.values(formErrors).forEach(val => {
        val.length > 0 && (valid = false);
    });

    //validate the form was filled out
    Object.values(rest).forEach(val => {
        val === null && (valid = false);
    })

    return valid;
}

class ContactEmailSent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
                name: null,
                email: null,
                mobile: null,
                city: null,
                message: null,
                formErrors:{
                    name: '',
                    email: '',
                    mobile: '',
                    city: '',
                    message: ''
                },
                formValidation: false,
                emailSent: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = e => {
        e.preventDefault();
        // this.setState({
        //     [e.target.name]: e.target.value
        // })

        const { name, value } = e.target;
        let formErrors = { ...this.state.formErrors};

        switch(name) {
            case 'name':
                formErrors.name = 
                    value.length <3 ? "Enter valid name" : '';
                break;
            case 'email':
                formErrors.email = 
                    formErrors.email = emailRegex.test(value) ? "" : 'Invalid email address';
                break;
            case 'mobile':
                formErrors.mobile = 
                    value.length < 10  ? "Enter valid mobile number " : '';
                break;
            case 'city':
                formErrors.city = 
                    value.length < 3  ? "Enter valid City " : '';
                break;
            case 'message':
                formErrors.message = 
                    value.length < 10  ? "Type atleast 10 chars " : '';
                break;
        }
        this.setState({formErrors, [name]: value}, () => console.log(this.state));
    }


    handleSubmit = (e) => {
        e.preventDefault();
        if(formValid(this.state)){
            console.log('submitting...');
            const data = {
                name: this.state.name,
                email: this.state.email,
                mobile: this.state.mobile,
                city: this.state.city,
                message: this.state.message
            }
            console.log(data);
            fetch(`https://emailapi-ue2x.onrender.com/email?name=${data.name}&email=${data.email}&mobile=${data.mobile}&city=${data.city}&msg=${data.message}`) 
            //query string url
            .then(res=>res.status === 200 ? this.setState({emailSent : true}) : this.setState({emailSent: false}))
            .catch(err => console.error(err))
           this.setState({formValidation : true}) 
           
        }
        else {
            console.error("FORM INVALID - DISPLAY ERROR MESSAGE"); 
            alert('Please fill all the details.');
            this.setState({formValidation : false})
        }

    }

    render(){

        const { formErrors } = this.state;
        
        

        return(
            <div className="w-full bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 ">
                <p>Just send us the information and we will call back within 24 hours.</p>
                <h1 className="text-left text-5xl font-bold">Contact Us</h1>
                <hr className="border-pink-600 border-4 border-solid w-1/4 mb-5" />
                <p>Ever Wondered How Much Painting Your Walls Cost? Find Out The Best Offers And Discount For Your Space With Our Handy Instant Cost Estimator.</p>
                <form onSubmit={this.handleSubmit}>
                <div className="mt-6 mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                    Your Name*
                    </label>
                    <input 
                        className={formErrors.name.length > 0 ?
                            "shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" : 
                            "shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                        }
                        name="name" 
                        type="text" 
                        placeholder="Enter your name" 
                        onChange = {this.handleChange}
                    />
                    {formErrors.name.length > 0 && (
                        <span className="text-red-500">{formErrors.name}</span>
                    )}
                </div>
                <div className="mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2" >
                    Your Email*
                    </label>
                    <input 
                        className={formErrors.email.length > 0 ?
                            "shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" : 
                            "shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                        }
                        name="email" 
                        type="email" 
                        placeholder="Enter your email address" 
                        onChange = {this.handleChange}
                        />
                        {formErrors.email.length > 0 && (
                        <span className="text-red-500">{formErrors.email}</span>
                    )}
                </div>
                <div className="mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2" >
                    Your Mobile*
                    </label>
                    <input 
                        className={formErrors.mobile.length > 0 ?
                            "shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" : 
                            "shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                        }
                        name="mobile" 
                        type="number" 
                        placeholder="Enter your Mobile number"
                        onChange = {this.handleChange}
                         />
                    {formErrors.mobile.length > 0 && (
                        <span className="text-red-500">{formErrors.mobile}</span>
                    )}
                </div>
                <div className="mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2" >
                    Your City*
                    </label>
                    <input 
                        className={formErrors.city.length > 0 ?
                            "shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" : 
                            "shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                        }
                        name="city" 
                        type="text" 
                        placeholder="Enter your city" 
                        onChange = {this.handleChange}
                        />
                        {formErrors.city.length > 0 && (
                        <span className="text-red-500">{formErrors.city}</span>
                    )}
                    {/* <p className="text-red-500 text-xs italic">Please choose a password.</p> */}
                </div>
                <div className="mb-2">
                    <label className="block text-gray-700 text-sm font-bold mb-2" >
                    Your Message*
                    </label>
                    <textarea 
                        className={formErrors.message.length > 0 ?
                            "shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" : 
                            "shadow appearance-none border  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                        }
                        name="message" 
                        type="textarea"
                        rows="3" 
                        placeholder="Enter your message" 
                        onChange = {this.handleChange}
                        />
                        {formErrors.message.length > 0 && (
                        <span className="text-red-500">{formErrors.message}</span>
                    )}
                    {/* <p className="text-red-500 text-xs italic">Please choose a password.</p> */}
                </div>
                <p className="text-gray-500 text-xs mb-3 text-center">
                <FontAwesomeIcon icon={faLock} className="mr-2"/>We guarantee 100% privacy. Your information will not be shared.
                </p>
                <div className="flex items-center justify-between">
                    <button className="w-full bg-pink-600 hover:bg-pink-800 text-white uppercase font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
                    Submit Now
                    </button>
                </div>
                {
                    this.state.emailSent ? 
                    <div class="bg-green-100 border border-green-400 text-green-700 p-5 mt-5 rounded relative text-center" role="alert">
                        <strong class="font-bold">Thanks for your submission. <br />We'll get back to you with 1-2 bussiness days.</strong>
                    </div> 
                  : ''
                }
                </form>
            </div>
        );
    }
}

export default ContactEmailSent;



// WEBPACK FOOTER //
// ./src/components/contactForm.jsx